module.exports = __webpack_public_path__ + "img/activejobs.0b029729.svg";